var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",staticClass:"w-100",style:({height: _vm.mapHeight}),attrs:{"id":"ol-map-container"}})}
var staticRenderFns = []

export { render, staticRenderFns }